import $ from 'jquery';
import { parseQuery, queryString } from '@/js/modules/query_params';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function getTagIds() {
    const params = queryString();
    let ids = (params['ids'] || '').split(',');
    if (ids[0] === '' && ids.length === 1) {
      ids = [];
    }
    return new Set(ids);
  }

  function setTagIds(ids) {
    const params = queryString();
    let url = null;
    params['ids'] = Array.from(ids).join(',');

    if (Object.keys(params).length > 0 && $.param(params).length > 0) {
      url = '?' + $.param(params);
    } else {
      url = window.location.pathname;
    }

    window.history.replaceState(null, '', url);
  }

  function updateTagsControls() {
    const selectedCheckboxesLength = $('.checkbox--tags:checked').length;
    const tagsCount = $('.data-table__tr').length;
    const totalSelectedTags = getTagIds().size;

    if (totalSelectedTags) {
      $('.h-d-button__text').text(`(${totalSelectedTags})`);
      $('.h-d-button--delete-tags').prop('disabled', false);

      $('.h-s-button--merge-tags').prop('disabled', totalSelectedTags <= 1);
      $('.checkbox--tags-check-all').prop('checked', selectedCheckboxesLength === tagsCount);
    } else {
      $('.h-d-button--delete-tags').prop('disabled', true);
      $('.h-s-button--merge-tags').prop('disabled', true);
      $('.h-d-button__text').text('');
    }
  }

  $(document).ready(() => {
    getTagIds().forEach((tagId) => {
      $(`.data-table__tr[data-id=${tagId}]`).find('.checkbox--tags').prop('checked', true);
    });
    updateTagsControls();
  });

  $(document).on('change', '.checkbox--tags', (e) => {
    const ids = getTagIds();
    const id = String($(e.target).closest('.data-table__tr').data('id'));
    const checked = $(e.target).is(':checked');
    const $tr = $(e.target).parents('.data-table__tr');
    $tr.toggleClass('data-table__tr--checked', checked);

    if (checked) {
      ids.add(id);
    } else {
      ids.delete(id);
    }
    const newIds = Array.from(ids).join(',');

    $('.pagination a').each(function (index, link) {
      const url = new URL(link.href);
      const params = parseQuery(url.search);
      params['ids'] = newIds;
      url.search = '?' + $.param(params);
      link.href = url.href;
    });

    setTagIds(ids);
    updateTagsControls();
  });

  $(document).on('change', '.checkbox--tags-check-all', (e) => {
    $('.checkbox--tags').prop('checked', $(e.target).prop('checked')).trigger('change');
    updateTagsControls();
  });

  $(document).on('click', '.h-d-button--delete-tags', (e) => {
    const selectedTagIds = Array.from(getTagIds());

    $('#modal--delete-tags-confirmation .d-button--confirm-delete').attr(
      'href',
      `/tags/delete_tags?tag_ids=${selectedTagIds}`
    );
    $('#modal--delete-tags-confirmation .modal__header').text(
      `Are you sure you want to delete ${selectedTagIds.length} selected tags?`
    );

    $('#modal--delete-tags-confirmation').modal();
  });

  $(document).on('click', '.h-s-button--merge-tags', (e) => {
    // assign a temporary name based on first selected tag
    const tmpName = $('.checkbox--tags:checked:first')
      .closest('.data-table__tr')
      .find('.data-table__td--tag-name')
      .text()
      .trim();
    $('.field--merge-tags').val(tmpName);

    const selectedTagIds = Array.from(getTagIds());
    $('#tag_ids').val(selectedTagIds);

    $('#modal--merge-tags').modal();
  });

  // The ajax-open modal is appended to the body on every open and jquery-modal only
  // hides it on close. Without this, reopening the form leaves stale copies behind and
  // the turbo stream replace targets the hidden one instead of the visible form.
  $(document).on($.modal.CLOSE, '.modal--tag-form', (e) => {
    $(e.target).remove();
  });

  $(document).on('click', '.tags-search-form__clear', (e) => {
    const $el = $(e.target);
    $el.siblings('.tags-search-form__field').val('');
    $el.parents('.tags-search-form').submit();
  });
});
